"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var createElement_1 = require("./createElement");
var fromHtml_1 = require("./fromHtml");
var safeInstanceOf_1 = require("../utils/safeInstanceOf");
function wrap(nodes, wrapper) {
    nodes = !nodes ? [] : safeInstanceOf_1.default(nodes, 'Node') ? [nodes] : nodes;
    if (nodes.length == 0 || !nodes[0]) {
        return null;
    }
    if (!wrapper) {
        wrapper = 'div';
    }
    if (!safeInstanceOf_1.default(wrapper, 'HTMLElement')) {
        var document_1 = nodes[0].ownerDocument;
        if (typeof wrapper === 'string') {
            wrapper = /^\w+$/.test(wrapper)
                ? document_1.createElement(wrapper)
                : fromHtml_1.default(wrapper, document_1)[0]; // This will be removed in next major release
        }
        else {
            wrapper = createElement_1.default(wrapper, document_1);
        }
    }
    var parentNode = nodes[0].parentNode;
    if (parentNode) {
        parentNode.insertBefore(wrapper, nodes[0]);
    }
    for (var _i = 0, nodes_1 = nodes; _i < nodes_1.length; _i++) {
        var node = nodes_1[_i];
        wrapper.appendChild(node);
    }
    return wrapper;
}
exports.default = wrap;
//# sourceMappingURL=wrap.js.map